/* Panier tiroir Serena (sans app). Contrat :
 *   document 'serena:cart:open'    -> ouvre le tiroir (re-fetch /cart.js)
 *   document 'serena:cart:updated' -> {detail:{item_count}} après chaque changement
 * Données (textes, handles, prix barrés, upsells) : <script id="serena-cart-data"> du snippet serena-cart-drawer. */
(function () {
  'use strict';
  if (window.__serenaCartReady) return;

  var TIMER_KEY = 'serena_cart_timer_end';
  var ICON_TRASH = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" width="20" height="20" fill="currentColor" aria-hidden="true" focusable="false"><path d="M11.5 8.25a.75.75 0 0 1 .75.75v4.25a.75.75 0 0 1-1.5 0v-4.25a.75.75 0 0 1 .75-.75Z"></path><path d="M9.25 9a.75.75 0 0 0-1.5 0v4.25a.75.75 0 0 0 1.5 0v-4.25Z"></path><path fill-rule="evenodd" d="M7.25 5.25a2.75 2.75 0 0 1 5.5 0h3a.75.75 0 0 1 0 1.5h-.75v5.45c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311c-.642.327-1.482.327-3.162.327h-.4c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311c-.327-.642-.327-1.482-.327-3.162v-5.45h-.75a.75.75 0 0 1 0-1.5h3Zm1.5 0a1.25 1.25 0 1 1 2.5 0h-2.5Zm-2.25 1.5h7v5.45c0 .865-.001 1.423-.036 1.848-.033.408-.09.559-.128.633a1.5 1.5 0 0 1-.655.655c-.074.038-.225.095-.633.128-.425.035-.983.036-1.848.036h-.4c-.865 0-1.423-.001-1.848-.036-.408-.033-.559-.09-.633-.128a1.5 1.5 0 0 1-.656-.655c-.037-.074-.094-.225-.127-.633-.035-.425-.036-.983-.036-1.848v-5.45Z"></path></svg>';
  var ICON_TAG = '<svg viewBox="0 0 20 20" width="12" height="12" aria-hidden="true" focusable="false"><path fill="currentColor" d="M3 4a1 1 0 0 1 1-1h5.6a1 1 0 0 1 .7.3l6.4 6.4a1 1 0 0 1 0 1.4l-5.6 5.6a1 1 0 0 1-1.4 0L3.3 10.3a1 1 0 0 1-.3-.7V4Zm3 3a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"></path></svg>';
  var ICON_MAGIC = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" width="100%" height="100%" fill="currentColor" aria-hidden="true"><path d="M5.702 4.253a.625.625 0 0 1 1.096 0l.196.358c.207.378.517.688.895.895l.358.196a.625.625 0 0 1 0 1.097l-.358.196a2.25 2.25 0 0 0-.895.894l-.196.359a.625.625 0 0 1-1.096 0l-.196-.359a2.25 2.25 0 0 0-.895-.894l-.358-.196a.625.625 0 0 1 0-1.097l.358-.196a2.25 2.25 0 0 0 .895-.895l.196-.358Z"></path><path fill-rule="evenodd" d="M12.948 7.89c-.18-1.167-1.852-1.19-2.064-.029l-.03.164a3.756 3.756 0 0 1-3.088 3.031c-1.15.189-1.173 1.833-.03 2.054l.105.02a3.824 3.824 0 0 1 3.029 3.029l.032.165c.233 1.208 1.963 1.208 2.196 0l.025-.129a3.836 3.836 0 0 1 3.077-3.045c1.184-.216 1.12-1.928-.071-2.107a3.789 3.789 0 0 1-3.18-3.154Zm-.944 6.887a5.34 5.34 0 0 1 2.542-2.647 5.305 5.305 0 0 1-2.628-2.548 5.262 5.262 0 0 1-2.488 2.508 5.329 5.329 0 0 1 2.574 2.687Z"></path></svg>';

  function esc(s) {
    return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function money(cents) {
    var neg = cents < 0;
    cents = Math.abs(Math.round(cents));
    var whole = String(Math.floor(cents / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    var dec = ('0' + (cents % 100)).slice(-2);
    return (neg ? '-' : '') + whole + ',' + dec + ' €';
  }

  var BRAND = 'Serena';   // fournisseur des produits Serena ; tout autre fournisseur est retiré du panier Serena

  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok) throw new Error(j && (j.description || j.message) || 'cart error');
        return j;
      });
    });
  }

  function getCart() {
    return fetch('/cart.js', { cache: 'no-store', headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }

  function store(method, key, value) {
    try {
      if (method === 'get') return window.localStorage.getItem(key);
      if (method === 'set') window.localStorage.setItem(key, value);
      if (method === 'del') window.localStorage.removeItem(key);
    } catch (e) { /* stockage indisponible */ }
    return null;
  }

  class SerenaCart extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;
      var node = document.getElementById('serena-cart-data');
      try { this.data = JSON.parse(node.textContent); } catch (e) { this.data = { masseur: '', gifts: [], compare: {}, upsells: [], strings: {} }; }
      this.S = this.data.strings || {};
      this.sheet = this.querySelector('[data-sc-sheet]');
      this.$lines = this.querySelector('[data-sc-lines]');
      this.$upsell = this.querySelector('[data-sc-upsell]');
      this.$empty = this.querySelector('[data-sc-empty]');
      this.$footer = this.querySelector('[data-sc-footer]');
      this.$announcement = this.querySelector('[data-sc-announcement]');
      this.$timer = this.querySelector('[data-sc-timer]');
      this.$timerText = this.querySelector('[data-sc-timer-text]');
      this.$bodyGroup = this.querySelector('[data-sc-body-group]');
      this.cart = null;
      this.lastFocus = null;
      this.busy = false;

      this.addEventListener('click', this.onClick.bind(this));
      this.addEventListener('change', this.onChange.bind(this));
      this.addEventListener('keydown', this.onKeydown.bind(this));
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && this.isOpen()) this.close(); }.bind(this));
      document.addEventListener('serena:cart:open', function (e) { this.open(e && e.detail); }.bind(this));

      this.clean();
      window.__serenaCartReady = true;
      if (window.__serenaCartPending) { window.__serenaCartPending = false; this.open({ refresh: true }); }
    }

    isOpen() { return this.classList.contains('is-open'); }

    open(detail) {
      if (!this.isOpen()) {
        this.lastFocus = document.activeElement;
        this.classList.add('is-open');
        document.documentElement.classList.add('serena-cart-open');
        this.startTick();
        window.setTimeout(function () { if (this.isOpen()) this.sheet.focus({ preventScroll: true }); }.bind(this), 0);
      }
      return this.refresh();
    }

    close() {
      this.classList.remove('is-open');
      document.documentElement.classList.remove('serena-cart-open');
      this.stopTick();
      if (this.lastFocus && this.lastFocus.focus) { try { this.lastFocus.focus({ preventScroll: true }); } catch (e) { /* ignore */ } }
    }

    /* ---------- données panier ---------- */

    refresh() {
      return getCart().then(function (cart) { return this.apply(cart, true); }.bind(this)).catch(function () { this.classList.remove('is-loading'); }.bind(this));
    }

    isGift(item) {
      var p = item.properties || {};
      return p._serena_cadeau != null || (this.data.gifts || []).indexOf(item.handle) !== -1;
    }

    /* garde-fous :
       - le panier est commun à toute la boutique : un article d'une autre marque (Syrae) ajouté ailleurs est retiré,
         pour que le panier et le checkout Serena ne contiennent que du Serena (fournisseur « Serena ») ;
       - un cadeau sans masseur au panier est retiré automatiquement. */
    guard(cart) {
      var self = this;
      var foreign = cart.items.filter(function (i) { return i.vendor !== BRAND; });
      var own = cart.items.filter(function (i) { return i.vendor === BRAND; });
      var hasMain = own.some(function (i) { return i.handle === self.data.masseur; });
      var gifts = hasMain ? [] : own.filter(function (i) { return self.isGift(i); });
      var drop = foreign.concat(gifts);
      if (!drop.length) return Promise.resolve(cart);
      var updates = {};
      drop.forEach(function (g) { updates[g.key] = 0; });
      return post('/cart/update.js', { updates: updates }).catch(function () { return cart; });
    }

    /* au chargement d'une page Serena : nettoie le panier sans ouvrir le tiroir (compteur de l'en-tête à jour) */
    clean() {
      return getCart().then(function (cart) {
        if (!cart.items.some(function (i) { return i.vendor !== BRAND; })) return cart;
        return this.guard(cart).then(function (c) {
          document.dispatchEvent(new CustomEvent('serena:cart:updated', { detail: { item_count: c.item_count, cart: c } }));
          return c;
        });
      }.bind(this)).catch(function () {});
    }

    apply(cart, fromOpen) {
      return this.guard(cart).then(function (c) {
        this.cart = c;
        this.syncTimer(c);
        this.render(c);
        this.classList.remove('is-loading');
        document.dispatchEvent(new CustomEvent('serena:cart:updated', { detail: { item_count: c.item_count, cart: c } }));
        return c;
      }.bind(this));
    }

    mutate(promiseFactory) {
      if (this.busy) return Promise.resolve();
      this.busy = true;
      this.classList.add('is-busy');
      return promiseFactory().then(function () { return getCart(); }).then(function (cart) { return this.apply(cart); }.bind(this))
        .catch(function () { return this.refresh(); }.bind(this))
        .then(function () { this.busy = false; this.classList.remove('is-busy'); }.bind(this));
    }

    change(key, qty) {
      return this.mutate(function () { return post('/cart/change.js', { id: key, quantity: Math.max(0, qty) }); });
    }

    addUpsell(variantId) {
      return this.mutate(function () {
        return post('/cart/add.js', { items: [{ id: Number(variantId), quantity: 1, properties: { _serena_upsell: '1' } }] });
      });
    }

    /* ---------- minuteur (10 min, départ au premier ajout, mémorisé) ---------- */

    syncTimer(cart) {
      if (!cart.item_count) { store('del', TIMER_KEY); return; }
      var end = parseInt(store('get', TIMER_KEY), 10);
      if (!end) store('set', TIMER_KEY, String(Date.now() + (this.data.timerMinutes || 10) * 60000));
      this.tick();
    }

    tick() {
      var end = parseInt(store('get', TIMER_KEY), 10);
      var left = end ? Math.max(0, Math.round((end - Date.now()) / 1000)) : (this.data.timerMinutes || 10) * 60;
      var txt = ('0' + Math.floor(left / 60)).slice(-2) + ':' + ('0' + (left % 60)).slice(-2);
      var tpl = this.S.timer || '';
      var out = tpl.replace('{timer}', txt);
      if (this._timerOut !== out) { this._timerOut = out; this.$timerText.textContent = out; }
    }

    startTick() { this.stopTick(); this.tick(); this._tick = window.setInterval(this.tick.bind(this), 1000); }
    stopTick() { if (this._tick) { window.clearInterval(this._tick); this._tick = null; } }

    /* ---------- rendu ---------- */

    compareOf(item) {
      var c = (this.data.compare || {})[String(item.variant_id)] || 0;
      return Math.max(c, item.original_price || 0, item.final_price || 0);
    }

    sortedItems(cart) {
      var self = this;
      var rank = function (i) {
        if (self.isGift(i)) return 2;
        if ((i.properties || {})._serena_upsell != null) return 1;
        return 0;
      };
      return cart.items.map(function (it, idx) { return { it: it, idx: idx }; })
        .sort(function (a, b) { return rank(a.it) - rank(b.it) || a.idx - b.idx; })
        .map(function (x) { return x.it; });
    }

    lineHTML(item) {
      var price = item.final_price;
      var cmp = this.compareOf(item);
      var save = (cmp - price) * item.quantity;
      var img = (item.featured_image && item.featured_image.url) || item.image || '';
      if (img) img += (img.indexOf('?') === -1 ? '?' : '&') + 'width=240';
      var alt = (item.featured_image && item.featured_image.alt) || item.title;
      var props = '';
      var p = item.properties || {};
      Object.keys(p).forEach(function (k) {
        if (k.charAt(0) === '_' || p[k] === '' || p[k] == null) return;
        props += '<div class="serena-cart__props">' + esc(k) + ' : ' + esc(p[k]) + '</div>';
      });
      var variant = item.variant_title && item.variant_title !== 'Default Title' ? '<div class="serena-cart__props">' + esc(item.variant_title) + '</div>' : '';
      return '<div class="serena-cart__item" data-key="' + esc(item.key) + '" data-qty="' + item.quantity + '">' +
        '<div class="serena-cart__thumb"><img src="' + esc(img) + '" alt="' + esc(alt) + '" width="120" height="120" decoding="async"></div>' +
        '<div class="serena-cart__item-body">' +
          '<div class="serena-cart__header-row">' +
            '<a class="serena-cart__name" href="' + esc(item.url) + '" title="' + esc(item.product_title || item.title) + '">' + esc(item.product_title || item.title) + '</a>' +
            '<button type="button" class="serena-cart__delete" data-sc-delete aria-label="' + esc(this.S.remove) + '">' + ICON_TRASH + '</button>' +
          '</div>' + variant + props +
          '<span class="serena-cart__price-stack"><span class="serena-cart__price">' + money(price) + '</span>' +
            (cmp > price ? '<span class="serena-cart__compare-at">' + money(cmp) + '</span>' : '') + '</span>' +
          '<div class="serena-cart__action-row">' +
            '<span class="serena-cart__qty">' +
              '<button type="button" class="serena-cart__qty-btn" data-sc-qty="decrease" aria-label="' + esc(this.S.decrease) + '">−</button>' +
              '<input type="text" inputmode="numeric" pattern="[0-9]*" class="serena-cart__qty-value" data-sc-qty-input value="' + item.quantity + '" aria-label="' + esc(this.S.quantity) + '" autocomplete="off">' +
              '<button type="button" class="serena-cart__qty-btn" data-sc-qty="increase" aria-label="' + esc(this.S.increase) + '">+</button>' +
            '</span>' +
            (save > 0 ? '<span class="serena-cart__savings-wrap"><span class="serena-cart__savings"><span class="serena-cart__savings-icon">' + ICON_TAG + '</span>' +
              '<span class="serena-cart__savings-text">' + esc((this.S.savings || '{amount}').replace('{amount}', money(save))) + '</span></span></span>' : '') +
          '</div>' +
        '</div>' +
      '</div>';
    }

    upsellHTML(cart) {
      var inCart = {};
      cart.items.forEach(function (i) { inCart[i.handle] = true; inCart[String(i.variant_id)] = true; });
      var self = this;
      var rows = (this.data.upsells || []).filter(function (u) { return !inCart[u.handle] && !inCart[String(u.variant)]; });
      if (!rows.length) return '';
      return '<div class="serena-cart__xs-header"><span class="serena-cart__xs-icon" aria-hidden="true">' + ICON_MAGIC + '</span>' +
        '<div class="serena-cart__xs-title"><p>' + esc(this.S.upsellTitle) + '</p></div></div>' +
        '<div class="serena-cart__xs-list">' + rows.map(function (u) {
          return '<div class="serena-cart__xs-row" data-handle="' + esc(u.handle) + '">' +
            '<div class="serena-cart__xs-thumb"><a href="' + esc(u.url) + '" target="_blank" rel="noopener noreferrer" tabindex="-1" aria-hidden="true">' +
              '<img src="' + esc(u.image) + '" alt="' + esc(u.title) + '" width="88" height="88" loading="lazy"></a></div>' +
            '<div class="serena-cart__xs-body">' +
              '<a class="serena-cart__xs-name" href="' + esc(u.url) + '" target="_blank" rel="noopener noreferrer" title="' + esc(u.title) + '">' + esc(u.title) + '</a>' +
              '<div class="serena-cart__xs-meta"><div class="serena-cart__xs-price-row"><span class="serena-cart__xs-price">' + money(u.price) + '</span>' +
                (u.compare > u.price ? '<span class="serena-cart__xs-price-original">' + money(u.compare) + '</span>' : '') + '</div></div>' +
            '</div>' +
            '<div class="serena-cart__xs-right"><span class="serena-cart__xs-discount"><p>' + esc(self.S.upsellLabel) + '</p></span>' +
              '<button type="button" class="serena-cart__xs-add" data-sc-upsell-add="' + esc(u.variant) + '" aria-label="' + esc(self.S.upsellAdd + ' ' + u.title) + '">' + esc(self.S.upsellAdd) + '</button></div>' +
          '</div>';
        }).join('') + '</div>';
    }

    render(cart) {
      var empty = !cart.items.length;
      this.$announcement.hidden = empty;
      this.$timer.hidden = empty;
      this.$bodyGroup.hidden = empty;
      this.$footer.hidden = empty;
      this.$empty.hidden = !empty;
      if (empty) { this.$lines.innerHTML = ''; this.$upsell.innerHTML = ''; this.$upsell.hidden = true; return; }

      var self = this;
      this.$lines.innerHTML = this.sortedItems(cart).map(function (i) { return self.lineHTML(i); }).join('');
      var up = this.upsellHTML(cart);
      this.$upsell.innerHTML = up;
      this.$upsell.hidden = !up;

      var compareTotal = 0;
      cart.items.forEach(function (i) { compareTotal += self.compareOf(i) * i.quantity; });
      var total = cart.total_price;
      var savings = Math.max(0, compareTotal - total);
      var row = this.querySelector('[data-sc-savings-row]');
      row.hidden = savings <= 0;
      this.querySelector('[data-sc-savings]').textContent = '−' + money(savings);
      this.querySelector('[data-sc-total]').textContent = money(total);
      var ct = this.querySelector('[data-sc-compare-total]');
      ct.hidden = compareTotal <= total;
      ct.textContent = money(compareTotal);
      this.tick();
    }

    /* ---------- évènements ---------- */

    onClick(e) {
      var t = e.target;
      if (!t.closest) return;
      if (t.closest('[data-sc-close]')) { this.close(); return; }
      var del = t.closest('[data-sc-delete]');
      if (del) { this.change(del.closest('[data-key]').getAttribute('data-key'), 0); return; }
      var q = t.closest('[data-sc-qty]');
      if (q) {
        var line = q.closest('[data-key]');
        var qty = parseInt(line.getAttribute('data-qty'), 10) || 1;
        this.change(line.getAttribute('data-key'), q.getAttribute('data-sc-qty') === 'increase' ? qty + 1 : qty - 1);
        return;
      }
      var add = t.closest('[data-sc-upsell-add]');
      if (add) { this.addUpsell(add.getAttribute('data-sc-upsell-add')); return; }
      if (t.closest('[data-sc-checkout]')) {   // dernier nettoyage juste avant le paiement (article ajouté depuis un autre onglet)
        getCart().then(this.guard.bind(this)).catch(function () {}).then(function () { window.location.href = '/checkout'; });
      }
    }

    onChange(e) {
      var input = e.target.closest && e.target.closest('[data-sc-qty-input]');
      if (!input) return;
      var line = input.closest('[data-key]');
      var qty = parseInt(String(input.value).replace(/\D/g, ''), 10);
      if (isNaN(qty)) { input.value = line.getAttribute('data-qty'); return; }
      this.change(line.getAttribute('data-key'), qty);
    }

    onKeydown(e) {
      if (e.key === 'Enter' && e.target.matches && e.target.matches('[data-sc-qty-input]')) { e.preventDefault(); e.target.blur(); return; }
      if (e.key !== 'Tab' || !this.isOpen()) return;
      var f = Array.prototype.slice.call(this.sheet.querySelectorAll('a[href], button:not([disabled]), input')).filter(function (el) { return el.offsetParent !== null && el.tabIndex !== -1; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && (document.activeElement === first || document.activeElement === this.sheet)) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  }

  if (!customElements.get('serena-cart')) customElements.define('serena-cart', SerenaCart);
})();
